<template>
  <div class="head-title">
    <div class="left">
      <ul class="breadcrumb">
        <li>
          <router-link to="/accounting/home" class="active">{{
            $t("accounting")
          }}</router-link>
        </li>
        <li>-</li>
        <li>
          <a class="active" href="#">{{ $t("Income Statement") }}</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="main">
    <div class="head">
      <div class="head1">
        <span>{{ $t("from") }}</span>
        <input type="date" :placeholder="$t('from')" v-model="from" />
        <span>{{ $t("to") }}</span>
        <input type="date" :placeholder="$t('to')" v-model="to" />
        <span>{{ $t("ccenter") }}</span>
        <select v-model="parent">
          <option v-for="x in level1" :key="x" :value="x.actnum">
            {{ x.namear }}
          </option>
        </select>
        <select v-model="parent2" v-if="level2.length > 0">
          <option v-for="x in level2" :key="x" :value="x.actnum">
            {{ x.namear }}
          </option>
        </select>
        <button type="submit" @click="submit">
          <i class="bi bi-search"></i> {{ $t("search") }}
        </button>
      </div>
      <div class="head2">
        <button type="submit" @click="exportToExcel">
            <i class="bi bi-file-earmark-excel"></i> {{ $t("Excel") }}
          </button>
        <button type="submit" @click="pdf">
          <i class="bi bi-filetype-pdf"></i> {{ $t("PDF") }}
        </button>
        <!-- <button type="submit" @click="exportToExcel"><i class="bi bi-file-earmark-excel"></i> Excel </button> -->
      </div>
    </div>
    <div class="body" id="main">
      <br />
      <div :style="{ direction: css.EN }">
        <h3>{{ $t("Income Statement") }}</h3>
        <h6>{{ $t("from") }} : {{ fromdate }} {{ $t("to") }} : {{ todate }}</h6>
        <table class="table">
          <thead style="position: static">
            <tr>
              <th colspan="2">{{ todate }}</th>
            </tr>
            <tr>
              <th style="width: 50%">{{ $t("Account") }}</th>
              <th>{{ $t("amount") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in data1" :key="i">
              <td v-if="i.sup == 'true'" class="childname">
                <router-link to="" @click="summary(i)">
                  {{ i.actnum }} -
                  <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
                </router-link>
              </td>

              <td v-if="i.sup == 'false'">
                {{ i.actnum }} -
                <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
              </td>
              <td v-if="i.sup == 'true'" class="child">
                {{ i.amount
                }}<span v-if="i.amount == null">{{ (i.amount = 0) }}</span>
              </td>
              <td v-if="i.sup == 'false'">
                <span v-if="i.amount != 0">{{ i.amount }}</span>
              </td>
            </tr>
            <tr v-for="i in data2" :key="i">
              <td v-if="i.sup == 'true'" class="childname">
                <router-link to="" @click="summary(i)">
                  {{ i.actnum }} -
                  <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
                </router-link>
              </td>

              <td v-if="i.sup == 'false'">
                {{ i.actnum }} -
                <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
              </td>
              <td v-if="i.sup == 'true'" class="child">
                {{ i.amount
                }}<span v-if="i.amount == null">{{ (i.amount = 0) }}</span>
              </td>
              <td v-if="i.sup == 'false'">
                <span v-if="i.amount != 0">{{ i.amount }}</span>
              </td>
            </tr>
            <tr class="total">
              <td>اجمالى الربح</td>
              <td>{{ tincome }}</td>
            </tr>
            <!-- <tr v-for="i in data3" :key="i">
              <td v-if="i.sup == 'true'" class="childname">
                <router-link to="" @click="summary(i)">
                  {{ i.actnum }} -
                  <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
                </router-link>
              </td>

              <td v-if="i.sup == 'false'">
                {{ i.actnum }} -
                <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
              </td>
              <td v-if="i.sup == 'true'" class="child">
                {{ i.amount
                }}<span v-if="i.amount == null">{{ (i.amount = 0) }}</span>
              </td>
              <td v-if="i.sup == 'false'">
                <span v-if="i.amount != 0">{{ i.amount }}</span>
              </td>
            </tr> -->
            <tr v-for="i in data4" :key="i">
              <td v-if="i.sup == 'true'" class="childname">
                <router-link to="" @click="summary(i)">
                  {{ i.actnum }} -
                  <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
                </router-link>
              </td>

              <td v-if="i.sup == 'false'">
                {{ i.actnum }} -
                <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
              </td>
              <td v-if="i.sup == 'true'" class="child">
                {{ i.amount
                }}<span v-if="i.amount == null">{{ (i.amount = 0) }}</span>
              </td>
              <td v-if="i.sup == 'false'">
                <span v-if="i.amount != 0">{{ i.amount }}</span>
              </td>
            </tr>
            <tr class="total">
              <td>صافى الربح قبل الفوائد و الضرائب و الزكاة</td>
              <td>{{ tincomenot }}</td>
            </tr>
            <tr v-for="i in data5" :key="i">
              <td v-if="i.sup == 'true'" class="childname">
                <router-link to="" @click="summary(i)">
                  {{ i.actnum }} -
                  <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
                </router-link>
              </td>

              <td v-if="i.sup == 'false'">
                {{ i.actnum }} -
                <span v-if="css.lang == 'ar'">{{ i.namear }}</span><span v-if="css.lang == 'en'">{{ i.nameen }}</span>
              </td>
              <td v-if="i.sup == 'true'" class="child">
                {{ i.amount
                }}<span v-if="i.amount == null">{{ (i.amount = 0) }}</span>
              </td>
              <td v-if="i.sup == 'false'">
                <span v-if="i.amount != 0">{{ i.amount }}</span>
              </td>
            </tr>
            <tr class="total">
              <td>صافي الربح</td>
              <td>{{ tincomet }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import html2pdf from "html2pdf.js";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
export default {
  async mounted() {
    const result2 = await axios.get("/data/getcostcenter");
    const result = await axios.get(
      `/reports/IncomeStatement/${this.fromdate}/${this.todate}`
    );
    if (result.status == 200) {
      this.branches = result2.data.data;
      this.level1 = this.branches.filter((x) => x.level == 1);
      this.data1 = result.data.data;
      this.data2 = result.data.data2;
      this.data4 = result.data.data4;
      this.data5 = result.data.data5;
      this.tincome = Number(
        this.data1[0].amount - this.data2[0].amount
      ).toFixed(2);
      this.tincomenot = Number(
        Number(this.tincome) -
        this.data4[0].amount
      ).toFixed(2);
      this.tincomet = Number(this.tincomenot - this.data5[0].amount).toFixed(2);
    }
  },
  props: ["css"],
  data() {
    return {
      fromdate: moment().startOf("year").format("YYYY-MM-DD"),
      todate: moment().format("YYYY-MM-DD"),
      data1: [],
      data2: [],
      tincome: 0,
      tincomenot: 0,
      tincomet: 0,
      from: moment().startOf("year").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
      parent: "",
      parent2: "",
      level1: [],
      level2: [],
      branches: [],
    };
  },
  methods: {
    summary(val) {
      this.$root.$router.push({
        path: `/accounting/GeneralLedgerSummaryMonthly/${val.actnum}/${val.namear}/${val.nameen}/${val.typeact}`,
      });
    },
    async submit() {
      const result = await axios.get(
        `/reports/IncomeStatement/${this.from}/${this.to}`
      );
      if (result.status == 200) {
        (this.parent = ""), (this.parent2 = "");
        this.todate = this.to;
        this.fromdate = this.from;
        this.data1 = result.data.data;
        this.data2 = result.data.data2;
        this.data4 = result.data.data4;
        this.data5 = result.data.data5;
        this.tincome = Number(
          this.data1[0].amount - this.data2[0].amount
        ).toFixed(2);
        this.tincomenot = Number(
          Number(this.tincome) -
          this.data4[0].amount
        ).toFixed(2);
        this.tincomet = Number(this.tincomenot - this.data5[0].amount).toFixed(
          2
        );
      }
    },
    pdf() {
      html2pdf(document.getElementById("main").innerHTML, {
        margin: 0.2,
        filename: "incomestatement.pdf",
        image: { type: "jpeg", quality: 100 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      });
    },
    exportToExcel() {
  // Prepare the data rows
  const rows = [];

  // Title and date
  rows.push([this.$t("Income Statement")]);
  rows.push([`${this.$t("from")} : ${this.fromdate} ${this.$t("to")} : ${this.todate}`]);
  rows.push([]); // empty row for spacing

  // Table headers
  rows.push([this.$t("Account"), this.$t("amount")]);
  
  // Helper to add account name (with language support)
  const getAccountName = (i) => {
    return `${i.actnum} - ${this.css.lang === 'ar' ? i.namear : i.nameen}`;
  };

  // Add data from each section (skip zero amounts where original does)
  [...this.data1, ...this.data2, ...this.data4, ...this.data5].forEach(i => {
    let amount = i.amount || 0;
    if (amount === null) amount = 0;
    if (i.sup === 'false' && amount === 0) return; // skip zero leaf amounts like original
    rows.push([getAccountName(i), amount]);
  });

  // Totals (use Arabic text from your template - adjust if you have translations)
  rows.push(["اجمالى الربح", this.tincome]);
  rows.push(["صافى الربح قبل الفوائد و الضرائب و الزكاة", this.tincomenot]);
  rows.push(["صافي الربح", this.tincomet]);

  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(rows);

  // Optional: auto-size columns
  const colWidths = rows.reduce((acc, row) => {
    row.forEach((cell, idx) => {
      const length = cell ? cell.toString().length : 10;
      acc[idx] = Math.max(acc[idx] || 10, length);
    });
    return acc;
  }, []);
  ws['!cols'] = colWidths.map(w => ({ wch: w + 2 }));

  XLSX.utils.book_append_sheet(wb, ws, "Income Statement");

  // Generate file and download
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
  saveAs(data, `Income_Statement_${this.fromdate}_to_${this.todate}.xlsx`);
},
  },
  watch: {
    async parent() {
      this.level2 = this.branches.filter(
        (x) => x.actnum.startsWith(this.parent) && x.actnum != this.parent
      );
      const result = await axios.get(
        `/reports/IncomeStatementcenter/${this.from}/${this.to}/${this.parent}`
      );
      if (result.status == 200) {
        this.todate = this.to;
        this.data1 = result.data.data;
        this.data2 = result.data.data2;
        this.data3 = result.data.data3;
        this.data4 = result.data.data4;
        this.data5 = result.data.data5;
        this.tincome = Number(
          this.data1[0].amount - this.data2[0].amount
        ).toFixed(2);
        this.tincomenot = Number(
          Number(this.tincome) +
          Number(this.data3[0].amount) -
          this.data4[0].amount
        ).toFixed(2);
        this.tincomet = Number(this.tincomenot - this.data5[0].amount).toFixed(
          2
        );
      }
    },
    async parent2() {
      const result = await axios.get(
        `/reports/IncomeStatementcenter/${this.from}/${this.to}/${this.parent2}`
      );
      if (result.status == 200) {
        this.todate = this.to;
        this.data1 = result.data.data;
        this.data2 = result.data.data2;
        this.data3 = result.data.data3;
        this.data4 = result.data.data4;
        this.data5 = result.data.data5;
        this.tincome = Number(
          this.data1[0].amount - this.data2[0].amount
        ).toFixed(2);
        this.tincomenot = Number(
          Number(this.tincome) +
          Number(this.data3[0].amount) -
          this.data4[0].amount
        ).toFixed(2);
        this.tincomet = Number(this.tincomenot - this.data5[0].amount).toFixed(
          2
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  // direction: v-bind("css.EN");
  padding: 0.5%;
}

.main {
  width: 98%;
  margin: 1%;
  padding: 1%;
  // box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  border-radius: 5px;
  border: ridge 0.5px;
}

.head {
  padding: 0.25%;
  display: flex;
  border-bottom-style: ridge;
}

.head1 {
  width: 70%;
}

.head1 input {
  margin: 0.5%;
  padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: #eee;
}

.head2 {
  width: 30%;
  text-align: center;
}

button {
  margin: 0.5%;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: rgba(98, 153, 174, 255);
  color: white;
}

.head2 button a {
  color: white;
}

.table {
  margin-top: 1%;
}

table thead tr {
  border-radius: 5px;
  background-color: #eee;
}

select {
  width: 15%;
  margin: 0.5%;
  // padding: 0.5%;
  border: none;
  border-radius: 5px;
  background-color: #eee;
}

@media screen and (max-width: 576px) {
  .table {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    background-color: white;
    font-size: xx-small;
  }
}
</style>
